import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';

import { UserState } from '@app/auth/user.state';
import { CanUseService, Feature } from '@app/shared/can-use.service';

let aiCheckForOrgId: null | number = null;

export const homePageGuard: CanActivateFn = (): UrlTree | boolean => {
  const canUseService = inject(CanUseService);
  const org = inject(UserState).org();
  const router = inject(Router);

  if (!org) {
    return true;
  }

  if (aiCheckForOrgId !== org.id) {
    const canUseRoboticTestingApp = canUseService.can(Feature.RoboticTestingApp);
    const canUseAiPlatformApp = canUseService.can(Feature.AiPlatformApp);

    aiCheckForOrgId = org.id;

    if (canUseAiPlatformApp && !canUseRoboticTestingApp) {
      router.navigate(['/ai'], { queryParams: { orgId: org.id }, queryParamsHandling: '' });
    }
  }

  // We need to use plans analytics since summary is resetting this to false when expiration date passes
  return org.plan?.analytics ? router.parseUrl('/analytics/home') : true;
};
